import { FormItem } from '../../../../commons/Form/Form.types';
import { LoginDIRFormSchema } from './LoginDIRForm.types';

export const loginDIRFormData: FormItem<LoginDIRFormSchema>[][] = [
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'password',
      placeholder: 'Votre mot de passe...',
      label: 'Mot de passe',
      type: 'password',
      required: true,
    },
  ],
];
